import { render, staticRenderFns } from "./CreateEkrm.vue?vue&type=template&id=357ed38e&scoped=true&"
import script from "./CreateEkrm.vue?vue&type=script&lang=js&"
export * from "./CreateEkrm.vue?vue&type=script&lang=js&"
import style0 from "./CreateEkrm.vue?vue&type=style&index=0&id=357ed38e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ed38e",
  null
  
)

export default component.exports